export default __webpack_public_path__ + "locales/tr/Files.json?hash=dbe510aed6543f46f775bf4180e6d6d0";